import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { theme } from "../../theme"; // 🟢 KHÔI PHỤC THEME GỐC BẢO VỆ NAVBAR
import { 
    Box, Button, Container, Table, TableBody, TableCell, TableHead, TableRow, 
    Pagination, TextField, Card, CardContent, Typography, Stack, Chip, TableContainer, 
    InputAdornment, CircularProgress
} from "@mui/material";
import { 
    Search as SearchIcon, 
    CheckCircleOutlined, 
    CancelOutlined, 
    CurrencyExchangeOutlined, 
    RefreshOutlined
} from "@mui/icons-material";
import axios from "axios";
import { useEffect, useState } from "react";
import swal from "sweetalert";
import { t } from "i18next";

// ==========================================
// THEME CHUẨN KÈM FONT PLUS JAKARTA SANS
// ==========================================
const metronicTheme = createTheme({
    palette: {
        background: { default: "#F5F8FA", paper: "#FFFFFF" }, 
        text: { primary: "#181C32", secondary: "#7E8299" }, 
        primary: { main: "#1B84FF", light: "#F1FAFF" },
        success: { main: "#50CD89", light: "#E8FFF3" },
        danger: { main: "#F1416C", light: "#FFF5F8" },
        warning: { main: "#FFC700", light: "#FFF8DD" },
    },
    typography: { fontFamily: "'Plus Jakarta Sans', sans-serif" },
    components: {
        MuiCard: { styleOverrides: { root: { borderRadius: "12px", boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.03)", border: "1px solid #E4E6EF" } } },
        MuiTableCell: { styleOverrides: { root: { borderBottom: "1px solid #EFF2F5 !important", padding: "14px 12px", color: "#3F4254", fontSize: "0.85rem", fontFamily: "'Plus Jakarta Sans', sans-serif !important" } } },
        MuiButton: { styleOverrides: { root: { fontFamily: "'Plus Jakarta Sans', sans-serif", textTransform: 'none' } } },
        MuiPaginationItem: { styleOverrides: { root: { fontWeight: 700 } } }
    }
});

// Khai báo Interceptors ở ngoài Component
axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("user");
        if (token) config.headers["Authorization"] = `Bearer ${token}`;
        return config;
    },
    (error) => Promise.reject(error)
);

function Request() {
    const [data, setData] = useState(null);
    const [data2, setData2] = useState(null);
    const [load, setLoad] = useState(true);
    const [isFetching, setIsFetching] = useState(false);
    const [searched, setSearched] = useState("");
    const [pages, setPage] = useState(1);

    function formatDate(m) {
        if (!m) return "";
        const d = new Date(m);
        return `${d.getUTCFullYear()}/${("0" + (d.getMonth() + 1)).slice(-2)}/${("0" + d.getDate()).slice(-2)}  ${("0" + d.getHours()).slice(-2)}:${("0" + d.getMinutes()).slice(-2)}`;
    }

    const requestSearch = (searchedVal) => {
        setSearched(searchedVal);
        if (searchedVal !== "") {
            const filteredRows = data2.filter((row) => {
                const a = row?.user?.username?.toString().toLowerCase().includes(searchedVal.toString().toLowerCase());
                const b = Number(row?.user?.iduser).toString().toLowerCase().includes(searchedVal.toString().toLowerCase());
                const c = row?.createdAt?.toString().toLowerCase().includes(searchedVal.toString().toLowerCase());
                return a || b || c;
            });
            setData(filteredRows);
            setPage(1);
        } else {
            setData(data2);
        }
    };

    const handleChangePage = (e, newPage) => {
        setPage(newPage);
    };

    useEffect(() => {
        if (load === true) {
            setIsFetching(true);
            axios
                .get(`${process.env.REACT_APP_API_URL}/payment/hoantra`, {})
                .then((res) => {
                    setData(res.data.data);
                    setData2(res.data.data);
                    setIsFetching(false);
                    setLoad(false);
                })
                .catch((err) => {
                    setIsFetching(false);
                    setLoad(false);
                });
        }
    }, [load]);

    // Xử lý Hành động Duyệt / Từ chối
    const handleAction = (id, statusAction) => {
        if (!load) {
            setIsFetching(true);
            const formData = { id: id, status: statusAction };
            axios
                .post(`${process.env.REACT_APP_API_URL}/payment/update`, formData)
                .then((res) => {
                    swal(t('success'), `Đã xử lý đơn thành công!`, "success");
                    setLoad(true); // Trigger reload
                })
                .catch((err) => {
                    swal(t('error'), "Có lỗi xảy ra", "error");
                    setIsFetching(false);
                });
        }
    };

    const tableHeadSx = {
        color: "#A1A5B7 !important", fontWeight: "800 !important", fontSize: "0.75rem !important", 
        backgroundColor: "#FFFFFF !important", borderBottom: "2px solid #EFF2F5 !important",
        textTransform: "uppercase !important", whiteSpace: "nowrap"
    };

    const renderStatus = (status) => {
        if (status === "Success" || status === "Accept") return <Chip label={status} size="small" sx={{ backgroundColor: '#DCFCE7', color: '#16A34A', fontWeight: 800, borderRadius: '6px' }} />;
        if (status === "Deny" || status === "Cancel") return <Chip label={status} size="small" sx={{ backgroundColor: '#FFF5F8', color: '#F1416C', fontWeight: 800, borderRadius: '6px' }} />;
        if (status === "Pending") return <Chip label={status} size="small" sx={{ backgroundColor: '#FFF8DD', color: '#FFC700', fontWeight: 800, borderRadius: '6px' }} />;
        return <Chip label={status} size="small" sx={{ backgroundColor: '#F5F8FA', color: '#7E8299', fontWeight: 800, borderRadius: '6px' }} />;
    };

    return (
        // 🟢 BỌC THEME GỐC Ở ĐÂY ĐỂ BẢO VỆ NAVBAR
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                
                {/* 🟢 BỌC THEME MỚI Ở TRONG ĐỂ LÀM ĐẸP GIAO DIỆN CHÍNH */}
                <ThemeProvider theme={metronicTheme}>
                    <style>{`
                        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
                        .safe-request-zone * { text-align: left; box-sizing: border-box; font-family: 'Plus Jakarta Sans', sans-serif !important; }
                    `}</style>

                    <Box className="safe-request-zone" component="main" sx={{ flexGrow: 1, py: 4, backgroundColor: 'background.default', minHeight: 'calc(100vh - 70px)', position: 'relative' }}>
                        
                        {/* LOADING MỜ TOÀN MÀN HÌNH */}
                        {isFetching && (
                            <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255,255,255,0.6)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(2px)' }}>
                                <CircularProgress size={50} sx={{ color: '#1B84FF' }} />
                            </Box>
                        )}

                        <Container maxWidth="xl">
                            
                            {/* HEADER & TÌM KIẾM */}
                            <Box mb={4} display="flex" justifyContent="space-between" alignItems="flex-end" flexWrap="wrap" gap={2}>
                                <Box>
                                    <Typography variant="h5" fontWeight="800" color="#181C32" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <CurrencyExchangeOutlined fontSize="large" color="primary" /> {t("history_refund")}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" mt={0.5}>Quản lý và xét duyệt các yêu cầu giao dịch</Typography>
                                </Box>
                                
                                <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap>
                                    <TextField 
                                        value={searched} 
                                        onChange={(e) => requestSearch(e.target.value)} 
                                        placeholder={t("search") + "..."} 
                                        size="small"
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start"><SearchIcon sx={{ color: '#A1A5B7', fontSize: '1.2rem' }} /></InputAdornment>,
                                            sx: { borderRadius: '8px', backgroundColor: '#FFFFFF', '& fieldset': { borderColor: '#E4E6EF' }, minWidth: '250px', fontSize: '0.9rem', height: '42px', fontWeight: '600' }
                                        }}
                                    />
                                    <Button 
                                        variant="outlined" 
                                        onClick={() => setLoad(true)}
                                        sx={{ height: '42px', borderRadius: '8px', fontWeight: 800, borderColor: '#E4E6EF', color: '#4B5675' }}
                                    >
                                        <RefreshOutlined sx={{ fontSize: '1.2rem', mr: 0.5 }}/> Tải lại
                                    </Button>
                                </Stack>
                            </Box>

                            {/* BẢNG DỮ LIỆU */}
                            <Card sx={{ backgroundColor: '#FFFFFF' }}>
                                <TableContainer sx={{ overflowX: 'auto' }}>
                                    <Table sx={{ minWidth: 1460 }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{...tableHeadSx, pl: 3}}>TÀI KHOẢN</TableCell>
                                                <TableCell sx={tableHeadSx}>ID NGƯỜI DÙNG</TableCell>
                                                <TableCell sx={tableHeadSx}>{t('detail')}</TableCell>
                                                <TableCell sx={tableHeadSx}>SỐ TIỀN GIAO DỊCH</TableCell>
                                                <TableCell sx={tableHeadSx}>TRẠNG THÁI</TableCell>
                                                <TableCell sx={tableHeadSx}>THỜI GIAN</TableCell>
                                                <TableCell align="right" sx={{...tableHeadSx, pr: 3}}>HÀNH ĐỘNG</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        
                                        <TableBody>
                                            {data && data.length > 0 ? (
                                                data.slice((pages - 1) * 10, (pages - 1) * 10 + 10).map((item) => (
                                                    <TableRow key={item._id} hover sx={{ verticalAlign: 'middle' }}>
                                                        
                                                        <TableCell sx={{ pl: 3 }}>
                                                            <Typography variant="body2" fontWeight="800" color="#1B84FF">
                                                                {item?.user?.username}
                                                            </Typography>
                                                        </TableCell>
                                                        
                                                        <TableCell sx={{ fontWeight: "700", color: "#4B5675" }}>
                                                            {item?.user?.iduser}
                                                        </TableCell>
                                                        
                                                        <TableCell sx={{ fontWeight: "600", color: "#181C32", maxWidth: '250px' }}>
                                                            {item?.detail}
                                                        </TableCell>
                                                        
                                                        <TableCell>
                                                            <Typography variant="body2" fontWeight="900" color="#16A34A">
                                                                {item?.money.toLocaleString("vi-VN")} đ
                                                            </Typography>
                                                        </TableCell>
                                                        
                                                        <TableCell>
                                                            {renderStatus(item?.status_payment)}
                                                        </TableCell>

                                                        <TableCell sx={{ color: "text.secondary", fontSize: "0.85rem", fontWeight: "600" }}>
                                                            {formatDate(new Date(item?.createdAt))}
                                                        </TableCell>
                                                        
                                                        <TableCell align="right" sx={{ pr: 3 }}>
                                                            <Stack direction="row" spacing={1} justifyContent="flex-end">
                                                                <Button
                                                                    variant="contained"
                                                                    color="success"
                                                                    size="small"
                                                                    startIcon={<CheckCircleOutlined />}
                                                                    onClick={() => handleAction(item?._id, "Accept")}
                                                                    disabled={item?.status_payment !== "Pending"}
                                                                    sx={{ fontWeight: 800, borderRadius: '6px', boxShadow: 'none' }}
                                                                >
                                                                    {t("submit")}
                                                                </Button>
                                                                <Button
                                                                    variant="contained"
                                                                    color="error"
                                                                    size="small"
                                                                    startIcon={<CancelOutlined />}
                                                                    onClick={() => handleAction(item?._id, "Deny")}
                                                                    disabled={item?.status_payment !== "Pending"}
                                                                    sx={{ fontWeight: 800, borderRadius: '6px', boxShadow: 'none' }}
                                                                >
                                                                    {t("deny")}
                                                                </Button>
                                                            </Stack>
                                                        </TableCell>
                                                        
                                                    </TableRow>
                                                ))
                                            ) : (
                                                <TableRow>
                                                    <TableCell colSpan={7} align="center" sx={{ py: 6, color: '#A1A5B7', fontWeight: 700 }}>
                                                        Không tìm thấy dữ liệu yêu cầu nào.
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                
                                <Box sx={{ p: 2, display: "flex", justifyContent: "flex-end", alignItems: "center", borderTop: '1px solid #EFF2F5' }}>
                                    {data != null ? <Pagination color="primary" shape="rounded" page={pages} count={Math.ceil((data.length || 0) / 10)} size="small" onChange={handleChangePage} /> : null}
                                </Box>
                            </Card>
                        </Container>
                    </Box>
                </ThemeProvider>
            </DashboardLayout>
        </ThemeProvider>
    );
}

export default Request;